import _startOfDay from 'date-fns/start_of_day'

export const isRelated = ({ alert, doc }) =>
  alert.relatedTo &&
  alert.relatedTo.filter(
    item => (item.sys && item.sys.id) === (doc.sys && doc.sys.id)
  ).length

export const isActive = alert => alert.active
export const isCurrent = alert => {
  const now = new Date()
  if (alert.dateEnd) {
    if (_startOfDay(now) > _startOfDay(alert.dateEnd)) return false
  }
  if (alert.dateStart) {
    if (now < _startOfDay(alert.dateStart)) return false
  }
  return true
}

export const filterRelatedAlerts = ({ alerts = [], doc }) => {
  // return global alerts if no doc defined
  alerts = alerts.filter(isActive).filter(isCurrent)
  return doc
    ? alerts.filter(alert => isRelated({ alert, doc }))
    : alerts.filter(alert => !alert.relatedTo || !alert.relatedTo.length)
}



// WEBPACK FOOTER //
// ./src/utils/alerts.js